import { render } from "./VerifyOtp.vue?vue&type=template&id=6e5f91f0&scoped=true"
import script from "./VerifyOtp.vue?vue&type=script&lang=js"
export * from "./VerifyOtp.vue?vue&type=script&lang=js"

import "./VerifyOtp.vue?vue&type=style&index=0&id=6e5f91f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5f91f0"]])

export default __exports__